import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\OfferController::validate
 * @see app/Http/Controllers/OfferController.php:288
 * @route '/{offerDomain}/{offerCode}/book/validate'
 */
export const validate = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: validate.url(args, options),
    method: 'post',
})

validate.definition = {
    methods: ["post"],
    url: '/{offerDomain}/{offerCode}/book/validate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\OfferController::validate
 * @see app/Http/Controllers/OfferController.php:288
 * @route '/{offerDomain}/{offerCode}/book/validate'
 */
validate.url = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
                    offerDomain: args[0],
                    offerCode: args[1],
                }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
                        offerDomain: args.offerDomain,
                                offerCode: args.offerCode,
                }

    return validate.definition.url
            .replace('{offerDomain}', parsedArgs.offerDomain.toString())
            .replace('{offerCode}', parsedArgs.offerCode.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\OfferController::validate
 * @see app/Http/Controllers/OfferController.php:288
 * @route '/{offerDomain}/{offerCode}/book/validate'
 */
validate.post = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: validate.url(args, options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\OfferController::validate
 * @see app/Http/Controllers/OfferController.php:288
 * @route '/{offerDomain}/{offerCode}/book/validate'
 */
    const validateForm = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: validate.url(args, options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\OfferController::validate
 * @see app/Http/Controllers/OfferController.php:288
 * @route '/{offerDomain}/{offerCode}/book/validate'
 */
        validateForm.post = (args: { offerDomain: string | number, offerCode: string | number } | [offerDomain: string | number, offerCode: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: validate.url(args, options),
            method: 'post',
        })
    
    validate.form = validateForm